<style scoped>
.snform {
  max-width: 400px;
}
</style>

<template>
  <div>
    <h1>{{ $t('registration.title') }}</h1>
    <b-spinner v-if="isRegistering" />
    <b-container v-else class="snform">
      <b-form id="form" @submit="onRegister">
        <b-form-group
          id="sn"
          :label="$t('serial')"
          label-for="serial"
          class="text-left"
        >
          <b-form-input
            id="serial"
            v-model="sn"
            required
            :placeholder="$t('registration.serialEnter')"
            :minlength="snLength"
            :maxlength="snLength"
            @keypress="isNumber($event)"
          ></b-form-input>
          <b-form-invalid-feedback v-if="errorMsg !== ''" :force-show="true">
            <p>{{$t(errorMsg)}}</p>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-button type="submit" variant="primary" :disabled="!validation">{{$t('register')}}</b-button>
      </b-form>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SetupStart',
  props: ['mac'],
  data() {
    return {
      sn: '',
      snLength: 11,
      online: false,
      isRegistering: false,
      registrationErrorMsgs: {
        'unknown serial number': "registration.serialUnknown",
        'client is disabled': "registration.disabled",
        'serial number already in use': "registration.serialInUse"
      },
      errorMsg: ''
    };
  },
  watch: {
    sn: function(newValue) {
      if(newValue.length != 0) {
        const result = newValue.replace(/\D/g, "")
          .match(/.{1,2}/g).join("-");
        this.$nextTick(() => this.sn = result);
      }
    }
  },
  computed: {
    validation() {
      return this.sn.length == this.snLength;
    }
  },
  methods: {
    onRegister() {
      if(this.validation) {

        this.errorMsg = '';
        this.isRegistering = true;

        const params = new URLSearchParams();
        params.append('sn', this.sn);

        axios
          .post('http://10.3.141.1:6762/api/v1/registration', params, { timeout: 60000 })
          .then(response => {
            if (response.status == 200 || response.status == 201) {
              // 201: client has already been registered unter this serial number
              this.$emit('registration_success', this.sn);
            }
          })
          .catch(error => {
            console.log(error);
            if (error.response && error.response.data in this.registrationErrorMsgs) {
              this.errorMsg = this.registrationErrorMsgs[error.response.data];
            } else {
              this.errorMsg = "registration.defaultError";
            }

            this.$emit('ensure_sensor_is_reachable');
          })
          .finally(() => {
            this.isRegistering = false;
          });
      }
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode < 48 || charCode > 57) && charCode != 45) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  }
}
</script>
